import React from 'react';
import cx from 'classnames';
import { RegionReportItemsLabel } from './RegionReportItemsLabel';
import styles from '../RegionReport.css';
import { YieldRegionReport } from '../../../../types';

export type YieldReportStatsLabelProps = {
  allowHover?: boolean;
  dataTestId: string;
  item: YieldRegionReport;
  onClick: (item: YieldRegionReport) => void;
  showIcon: boolean;
  index: number;
  cropCode: string;
  cropNominalWeight?: number;
};

export const YieldReportStatsLabel = ({
  allowHover = true,
  dataTestId,
  index,
  item,
  onClick,
  showIcon,
  cropCode,
  cropNominalWeight
}: YieldReportStatsLabelProps) => {
  const { averageYield, area } = item;

  return (
    <div
      className={cx(styles.content, { [styles.contentRow]: allowHover })}
      key={`dmb-region-report-item-${item.label}`}
      onClick={() => onClick(item)}
      data-test-id={`frr-region-report-${dataTestId}-item`}
    >
      <div className={styles.first}>
        <div data-test-id={`dmb-region-report-${dataTestId}-label`}>
          {item.label}
        </div>
      </div>
      <RegionReportItemsLabel 
        area={area} 
        averageYield={averageYield} 
        dataTestId={dataTestId}
        showIcon={showIcon}
        index={index}
        cropCode={cropCode}
        cropNominalWeight={cropNominalWeight}
       />
    </div>
  );
};